const formControlLabelFormControlAbel = {
  label: 'POR DEMANDA (SEM TEMPO DEFINIDO)'
};

export default formControlLabelFormControlAbel;
